import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ActivityLogFilterEntity } from '../../domain/entities/ActivityLogFilterEntity'

export class ActivityLogFilterModel extends ActivityLogFilterEntity {
  constructor(dataDto: ActivityLogFilterEntity) {
    super()
    mapEntityProperties<ActivityLogFilterEntity>(this, dataDto)
  }
}
